import React, { useEffect, useState } from 'react';
import { BASE_URL } from '@utils/config';
import axios from 'axios';

const Maintenance = () => {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkApi = async () => {
      try {
        // No auth needed — any HTTP response (even 401/403) means the server is up
        await axios.get(BASE_URL, { timeout: 10000 });
        window.location.replace('/login');
      } catch (error) {
        if (error.response) {
          // Server replied with an error status → it's up, go to login
          window.location.replace('/login');
        }
        // No response at all → server is truly down, stay on maintenance
        setChecking(false);
      }
    };

    checkApi();
    const interval = setInterval(checkApi, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='container__'>
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <div className="animation_main">
            <div className="one_main spin-one"></div>
            <div className="two_main spin-two"></div>
            <div className="three_main spin-one"></div>
          </div>

          <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#2d3748', marginBottom: '0.5rem' }}>
            En maintenance
          </h1>
          <p style={{ color: '#4a5568', marginBottom: '1rem', fontSize: '1.25rem', paddingBottom: '1rem' }}>
            Notre site est actuellement en maintenance. Nous reviendrons bientôt. Merci de votre compréhension.
          </p>
          {checking && (
            <p style={{ color: '#a0aec0', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
              Vérification de la disponibilité du serveur...
            </p>
          )}
          <a href="/login" style={{ color: '#f56565', textDecoration: 'underline', paddingBottom: '1rem', display: 'block' }}>
            Ou essayez de vous connecter plus tard
          </a>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
